/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Tile_Phone_SubtitleInputs */

const en_home_hero_tile_phone_subtitle = /** @type {(inputs: Home_Hero_Tile_Phone_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available anytime`)
};

const fr_home_hero_tile_phone_subtitle = /** @type {(inputs: Home_Hero_Tile_Phone_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible à tout moment`)
};

/**
* | output |
* | --- |
* | "Available anytime" |
*
* @param {Home_Hero_Tile_Phone_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_tile_phone_subtitle = /** @type {((inputs?: Home_Hero_Tile_Phone_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Tile_Phone_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_tile_phone_subtitle(inputs)
	return fr_home_hero_tile_phone_subtitle(inputs)
});